import { useEffect, useState } from "react"

import {
  Alert,
  AlertTitle,
  Box,  
  FormControlLabel,
  TextField,
} from "@mui/material"
import { RoundedButton } from "../../ui/roundButton"
import CustomSwitch from "../../ui/CustomSwitch"
import SaveIcon from "@mui/icons-material/Save"

import {
  SettingsSuggestOutlined as SettingsSuggestOutlinedIcon,
  Lock as LockIcon,
} from "@mui/icons-material"

import { renderExportAutomatic } from "../../../services/utils"
import { useReportsSettings } from "./useReportsSettings"
import { getEnterprise } from "../../../services/scout"

const ReportsPage = () => {
  const { loading, saving, settings, setSettings, save } = useReportsSettings()
  
  const [shouldRenderContent, setShouldRenderContent] = useState(true)

  useEffect(() => {
    const loadEnterprise = async () => {
      const data = await getEnterprise()
      setShouldRenderContent(renderExportAutomatic(data))
    }

    void loadEnterprise()
  }, [])

  return (
    <>
      {shouldRenderContent
        ? <section className="scout-settings-section">
          <div className="scout-settings-section__label">
            <SettingsSuggestOutlinedIcon />
            <span>Relatório diário</span>
          </div>

          <Box
            className="scout-settings-card scout-settings-card--stacked"
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              p: 3,
              alignItems: "flex-start",
            }}
          >
            <FormControlLabel
              label="Enviar por e-mail todas as conversas do dia anterior"
              sx={{ 
                margin: 0,
                gap: 1.5,
                alignItems: "center", 
              }}
              control={
                <CustomSwitch
                  //activeColor="#46abe3"
                  checked={settings.send_scout_email}
                  onChange={() =>
                    setSettings((prev) => ({
                      ...prev,
                      send_scout_email: !prev.send_scout_email,
                    }))
                  }
                />
              }
            />

            <Alert
              severity="info"
              sx={{ width: "100%", borderRadius: 2 }}
            >
              Um arquivo .zip será enviado para cada telefone destinatário, contendo
              textos, imagens, áudios e outras mídias. A exportação ocorrerá
              diariamente à meia-noite, sempre que houver novas conversas a serem
              exportadas.
            </Alert>

            {settings.send_scout_email ? (
              <TextField
                size="small"
                label="E-mail"
                fullWidth
                sx={{ maxWidth: "30rem" }}
                type="email"
                value={settings.scout_email}
                onChange={(event) =>
                  setSettings((prev) => ({
                    ...prev,
                    scout_email: event.target.value,
                  }))
                }
              />
            ) : null}

            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
              <RoundedButton
                rounded={settings.scout_export_type === "pdf" ? "filled" : "outlined"}
                onClick={() =>
                  setSettings((prev) => ({
                    ...prev,
                    scout_export_type: "pdf",
                  }))
                }
                sx={{ minWidth: 88, padding: "8px 20px" }}
              >
                PDF
              </RoundedButton>

              <RoundedButton
                rounded={settings.scout_export_type === "csv" ? "filled" : "outlined"}
                onClick={() =>
                  setSettings((prev) => ({
                    ...prev,
                    scout_export_type: "csv",
                  }))
                }
                sx={{ minWidth: 88, padding: "8px 20px" }}
              >
                CSV
              </RoundedButton>
            </Box>

            <RoundedButton
              onClick={save}
              disabled={saving || loading}
              startIcon={<SaveIcon />}
              sx={{ mt: 1 }}
            >
              {saving || loading ? "Salvando..." : "Salvar"}
            </RoundedButton>
          </Box>
        </section>
        : <Alert severity="info" icon={<LockIcon fontSize="inherit" />}>
          <AlertTitle>Recurso indisponível no seu plano.</AlertTitle>
        </Alert>
      }
    </>
  )
}

export default ReportsPage